import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material';
import { PipesModule } from '../core/pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MaterialModule,
        PipesModule,
        ReactiveFormsModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        MaterialModule,
        PipesModule,
        ReactiveFormsModule
    ]
})
export class SharedModule
{
}
